import React from 'react';
import DynamicForm from "../../../components/organism/DynamicForm";
import { Box } from '@material-ui/core';
import useStyles from './style';
import { COMPONENT_LOCATOR } from './locators'
import { getUId } from '../../../../utils/utility';

const SurveyScript = (props) => {
  const classes = useStyles();
  const uid = getUId(props);

  return (
    <Box uid={uid} data-locator={COMPONENT_LOCATOR} className={classes.root}>
      {/* microsoft dynamic survey form, just pass survey name as a prop*/}
      <DynamicForm
        apiEndpoint={props.fields.name.value}
        originalProps={props}
      />
    </Box>
  );
};

export default SurveyScript;
